import { type ReactNode } from "react";

import { Link } from "react-router-dom";

import { isSectionEnabled } from "../lib/content.js";
import Icon from "./Icon.jsx";
import { type IconName } from "./Icon.tsx";

// Grade de cards de navegação. `to` é resolvido relativo ao locale corrente
// pelo próprio Link do router quando começa com "/", então as páginas .mdx
// escrevem caminhos absolutos já com o idioma: /pt/docs/quickstart.
export function Cards({ children }: { children?: ReactNode }) {
  return <div className="intro-cards">{children}</div>;
}

// /pt/playground → "playground". Só interessa o segundo segmento.
const sectionOf = (path: string | undefined): string | null =>
  String(path || "")
    .split("/")
    .filter(Boolean)[1] || null;

interface CardProps {
  icon?: IconName | (string & {});
  title?: ReactNode;
  to?: string;
  href?: string;
  children?: ReactNode;
}

export function Card({ icon, title, to, href, children }: CardProps) {
  // Um card apontando para seção desligada levaria a um redirect — na prática,
  // um link morto no meio da introdução. Desligar a seção some com o card
  // sozinho, sem precisar caçar referências pelos .mdx.
  const section = to ? sectionOf(to) : null;
  if (section && !isSectionEnabled(section)) return null;

  const body = (
    <>
      {icon && (
        <div className="intro-card-icon">
          <Icon name={icon} size={20} />
        </div>
      )}
      <div>
        <div className="intro-card-title">{title}</div>
        {children && <div className="intro-card-desc">{children}</div>}
      </div>
    </>
  );
  if (href) {
    return (
      <a className="intro-card" href={href} target="_blank" rel="noreferrer">
        {body}
      </a>
    );
  }
  return (
    <Link className="intro-card" to={to || "#"}>
      {body}
    </Link>
  );
}

export default Cards;
